module.exports = __webpack_public_path__ + "components/flag/static/square/uy-dd82e774a80b26806ff371e4c493ec85.svg";